export default __webpack_public_path__ + "static/media/createActionH1@3x.12937c6e.png";